var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinimilistliving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 29.2998C20.5678 29.2998 26.5 36.2665 26.5 36.2665C26.5 36.2665 20.5678 43.2332 13.25 43.2332C5.93217 43.2332 0 36.2665 0 36.2665C0 36.2665 5.93217 29.2998 13.25 29.2998Z",
    fill: "#CEEBDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.057 21.9716C27.2315 27.1459 26.5 36.2669 26.5 36.2669C26.5 36.2669 17.379 36.9984 12.2046 31.824C7.03016 26.6496 7.76161 17.5287 7.76161 17.5287C7.76161 17.5287 16.8826 16.7972 22.057 21.9716Z",
    fill: "#B5E1CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.75 29.2998C32.4322 29.2998 26.5 36.2665 26.5 36.2665C26.5 36.2665 32.4322 43.2332 39.75 43.2332C47.0678 43.2332 53 36.2665 53 36.2665C53 36.2665 47.0678 29.2998 39.75 29.2998Z",
    fill: "#099A4F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9428 21.9717C25.7684 27.146 26.4999 36.267 26.4999 36.267C26.4999 36.267 35.6209 36.9985 40.7953 31.8241C45.9697 26.6497 45.2382 17.5287 45.2382 17.5287C45.2382 17.5287 36.1173 16.7973 30.9428 21.9717Z",
    fill: "#6BC295"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4666 23.0166C33.4666 30.3344 26.4999 36.2666 26.4999 36.2666C26.4999 36.2666 19.5332 30.3344 19.5332 23.0166C19.5332 15.6988 26.4999 9.7666 26.4999 9.7666C26.4999 9.7666 33.4666 15.6989 33.4666 23.0166Z",
    fill: "#9DD7B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimilistliving);
export default __webpack_public_path__ + "static/media/minimilistliving.6467132b21cf765d245988a5cdaed8f7.svg";
export { ForwardRef as ReactComponent };